import { lazy } from 'react';

export const ToolsPageLazy = lazy(() => import('./ToolsPage'));
